export default {
    newDesign: true,
    parameters: {
        landing_id: "IdQM",
        segment: 4
    },
    title: "Dari Ide ke Website & Desain Digital | Kodland",
    downtimeUrl: "https://www.kodland.org/id",
    startPage: {
        title:
            "Jawab pertanyaan untuk mendaftar kelas percobaan pertama Anda.",
        subtitle: "Kami mengubah minat terhadap teknologi menjadi keuntungan:<br>💬 Temukan bakat anak Anda dengan cara yang menyenangkan<br>🌐 Hanya perlu komputer dan koneksi internet<br>💙 Lebih dari 270 anak mendaftar hanya hari ini",
        image: {
            url: "/welcome/indonesia_longquiz_fwd_desk.png",
            style: {
                height: "100%",
                "max-height": "100vh",
            },
        },
        imageMobile: {
            url: "/welcome/indonesia_longquiz_fwd_mob.png",
            style: {
                width: "100%",
            },
        },
        button: "Mari kita mulai 🔥",
    },
    stopPage: {
        image: "/welcome/quizV2/no-computer.png",
        title: "Terima kasih atas kepercayaan Anda pada platform pendidikan kami!",
        subtitle:
            "Sayangnya, tablet atau ponsel tidak sesuai untuk mengikuti pelajaran kami. Kami akan sangat senang melihat Anda di kelas berikutnya!",
    },
    quizRotateBySteps: {
        1: {
            title: "Berapa usia anak Anda?",
            type: "age",
            button: "",
        },
        2: {
            question: "Bagaimana biasanya anak Anda menghabiskan waktu luangnya?",
            answers: [
                "📱 Bermain game di HP atau komputer",
                "👽 Menonton kartun",
                "🙌 Bermain permainan papan",
                "😊 Menghabiskan waktunya dengan keluarga",
                "👥 Menghabiskan waktunya dengan teman",
                "🤸 Bermain kegiatan olahraga",
                "🎨 Melakukan aktivitas seni: menggambar, musik, akting, dsb.",
            ],
        },
        3: {
            question: "Apakah anak Anda mengikuti kegiatan ekstrakurikuler di luar pembelajaran sekolah?",
            answers: [
                "📚 Kelas yang membantu untuk meningkatkan nilai pembelajaran",
                "🤸 Ya. Kegiatan olahraga",
                "🎨 Ya. Kelas seni",
                "💻 Ya. Kelas koding dan ilmu komputer",
                "⛺ Ya. Pramuka",
                "✖ Tidak. Anak tidak memiliki waktu untuk itu",
            ],
        },
        4: {
            question:
                "Untuk mengikuti kelas gratis ini, Anda perlu menggunakan komputer atau laptop (bukan HP) dengan koneksi internet stabil. Apakah Anda memiliki komputer/laptop di rumah?",
            answers: [
                "💻 Ya, kami memiliki komputer/laptop di rumah",
                {
                    answer: "❌ Tidak, kami tidak memiliki komputer/laptop di rumah",
                    stopAnswer: true,
                },
            ],
        },
        5: {
            title: "🎉 Tinggal satu langkah lagi!",
            typeInfo: "congrats",
            subtitle:
                "Bantu anak Anda menjelajahi sisi kreatifnya melalui pemrograman dan desain digital.<br>🌟 Lebih dari 200.000 anak sudah belajar dan berkarya bersama kami.",
            button: "📅 Pesan kelas gratis sekarang!",
        },
        6: {
            title: "🎉 Daftar kelas percobaan gratis",
            type: "one-page-contacts",
            subtitle: "Di pelajaran pertama, anak Anda akan membuat mini-game — dan Anda juga bisa ikut!",
            button: "✨ Sempurna! Tinggal satu langkah lagi.",
        },
        7: {
            title: "",
            type: "timeslot",
            subtitle: "",
            button: "",
        },
        8: {
            title: "Tinjau detail berikut untuk menyelesaikan pendaftaran ✨",
            typeInfo: "pc-laptop",
            subtitle:
                "Harap diperhatikan bahwa Anda akan membutuhkan komputer atau laptop yang berfungsi untuk pelajaran, dan Anda harus menemani anak Anda selama kelas berlangsung. Mohon diingat bahwa pelajaran ini bersifat individual dan personal.",
            button: "Selanjutnya bagaimana?",
        },
        9: {
            title: "Sebelum kelas uji coba, periksa email dan WhatsApp Anda 📞",
            typeInfo: "whatsapp",
            subtitle:
                "Kami akan mengirimkan pengingat 24 jam sebelum kelas dimulai dan meminta Anda untuk mengonfirmasikan kehadiran Anda 2 jam sebelum kelas dimulai. Sangat penting untuk tetap berkomunikasi agar kelas tidak dibatalkan.",
            button: "Selanjutnya bagaimana?",
        },
        10: {
            title: "Kelas akan diadakan di platform kami 💻",
            typeInfo: "classroom",
            subtitle:
                "Anda akan menerima tautan dan kode unik melalui WhatsApp dan email. Klik saja tautannya, dan Anda akan langsung diarahkan ke kelas. Tidak perlu aplikasi tambahan, tidak perlu mengunduh apa pun.",
            button: "Mengerti ✅",
        },
    },
};
